import api from 'services/api/microfwk';
import _ from 'lodash';

export const getCancelSuscription = (params = {}) =>
  api
    .get('/services/payway/cancelsuscription', {
      params,
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
